<template>
  <div class="login-form">
    <div class="g-signin2"></div>
    <div style="margin-bottom: 30px;">
      <va-button class="th-google-sign-in th-btn-google" @click.prevent="googleSignIn" type="subtle" style="margin-bottom: 15px" block>
        <img class="th-icon-btn" src="/img/google.png" alt="google-logo">
        Masuk Dengan Google
      </va-button>
      <va-button class="th-btn-facebook" @click.prevent="loginFb" type="primary" block>
        <img class="th-icon-btn" src="/img/facebook.png" alt="google-logo">
        Masuk Dengan Facebook
      </va-button>
    </div>
    <div class="th-separator" style="margin-bottom: 25px;">atau</div>
    <va-form ref="form" type="vertical" class="th-form">
      <va-form-item label="Email">
        <va-input name="Email" v-model="login.email" />
      </va-form-item>
      <va-form-item class="relative" label="Kata Sandi" style="margin-bottom: 30px;">
        <small class="th-lupa-sandi th-hover-pointer" @click.prevent="goTo('Lupa Sandi')">Lupa Sandi?</small>
        <va-input name="Email" type="password" v-model="login.password" />
      </va-form-item>
      <button type="submit" @click.prevent="signin" class="va-btn va-btn-block va-btn-md va-btn-primary">
        <div>Masuk</div>
      </button>
      <div style="margin-top: 30px;" class="text-center">
        <small>Tidak Punya Akun? <span class="th-link small th-hover-pointer" @click.prevent="goTo('Daftar')">Daftar</span></small>
      </div>
    </va-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login: {
        email: '',
        password: '',
      },
    }
  },
  methods: {
    async loginFb() {
      const FB = window.FB
      FB.login(async ({ status, authResponse }) => {
        if (status === 'connected') {
          FB.api('/me', 'GET', { fields: 'name,email,first_name,middle_name,last_name' }, async (response) => {
            try {
              const { message, user } = await this.$store.dispatch('user/USER_FIND_BY', { findBy: { email: response.email }, data: response })
              if (message.split('_').includes('SUCCESS')) {
                this.setUpAfterSuccessLogin(user)
              } else {
                // console.log('masuk')
                // console.log(profile, profile.getName())
                const user = {
                  email: response.email,
                  // firstName: getFirstName(response.first_name, response.middle_name),
                  // lastName: response.last_name,
                  fbIdToken: authResponse.accessToken,
                  // profpic: profile.getImageUrl(),
                }
                // console.log(user)
                this.notification.warning({
                  title: 'Akun Anda Belum Terdaftar',
                  message: 'Silahkan registrasi terlebih dahulu.',
                  duration: 5000,
                })
                // console.log(user, 'jifjidjfidjifdi')
                this.$router.push({ name: 'Daftar', query: { ...user } })
              }
            } catch (err) {
              console.log(err)
            }
          })
        } else {
        }
      }, { scope: 'public_profile,email' })

      // function getFirstName(firstName, middleName) {
      //   if (!middleName) return firstName
      //   else if (!firstName) return middleName
      //   return firstName + ' ' + middleName
      // }
    },
    async googleSignIn() {
      try {
        const googleUser = await this.$gAuth.signIn()
        // const authCode = await this.$gAuth.getAuthCode()
        const idToken = googleUser.getAuthResponse().id_token
        // const isSignIn = this.$gAuth.isAuthorized
        const { message, data, googleIdToken } = await this.$store.dispatch('user/GOOGLE_SIGN_IN', { idToken })
        // console.log(message)
        if (message.split('_').includes('SUCCESS')) {
          this.setUpAfterSuccessLogin(data)
        } else {
          // console.log('masuk')
          const profile = googleUser.getBasicProfile()
          // console.log(profile, profile.getName())
          const query = {
            email: profile.getEmail(),
            // firstName: profile.getGivenName(),
            // lastName: profile.getFamilyName(),
            // profpic: profile.getImageUrl(),
            googleIdToken,
          }
          // console.log(user)
          this.notification.warning({
            title: 'Akun Anda Belum Terdaftar',
            message: 'Silahkan registrasi terlebih dahulu.',
            duration: 5000,
          })
          // console.log(user, 'jifjidjfidjifdi')
          this.$router.push({ name: 'Daftar', query })
        }
      } catch (err) {
        console.log(err)
      }
    },
    demoAkun() {
      console.log('masuk')
    },
    goTo(routeName) {
      if (routeName === this.$route.name) return
      this.$router.push({ name: routeName })
    },
    async signin() {
      try {
        // console.log(this.$store.state)
        // console.log(this.$store.state.user)
        const data = await this.$store.dispatch('user/SIGNIN', { ...this.login })
        // console.log('data', data.user)
        // const expireDate = new Date().setMonth(new Date().getMonth() + 1) // one month expiration
        // const properExpireDate = new Date(expireDate)
        // this.$store.commit('user/SET_STATE', {})
        this.setUpAfterSuccessLogin(data)
      } catch (err) {
        console.log(err)
      }
      // console.log(this.$cookies.get('sessionId'))
      // console.log(this.$cookies.remove('sessionId'))
      // console.log(this.$cookies.get('sessionId'), 'masuk')
    },
    setUpAfterSuccessLogin(data) {
      const user = data.user || data
      this.$cookies.set('sessionId', user.sessionId)
      // this.$cookies.set('sessionId', token, null, '/')
      // const sessionId = this.$cookies.get('sessionId')
      // console.log(sessionId)
      this.$store.commit('user/SET_STATE', { sessionId: user.sessionId })
      this.$cookies.set('user', user, null, '/')
      if (!this.$route.query.redirect) this.$router.push({ name: 'Utama' })
      else {
        const redirectNameRoute = this.$route.query.redirect
        this.$router.push({ path: redirectNameRoute })
      }
      this.notification.success({
        title: 'Selamat Datang ' + user.name,
        duration: 5000,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/components/Kit/utils.scss';

.login-form {
  .th-lupa-sandi {
    position: absolute;
    right: 0px;
    top: 3px;
    color: $gray3;
    &:hover {
      text-decoration: underline;
    }
  }

  .th-btn {
    &-facebook {
      background-color: #1977F2;
      &:hover {
        background-color: #1977f2dc!important;
      }
    }

    &-google {
      border-color: #E9EBEE;
      color: $black-blue;

      &:hover {
        background-color: #e9ebeec5!important;
        color: $black-blue!important;
      }
    }
  }
  .th-icon {
    &-btn {
      position: absolute;
      left: 0;
    }
  }
}
</style>
